import React from 'react'
import CloseIcon from '../../../../../../asset/Close-X_Thin_FFFFFF_ldpi.png'

const ImageViewModel = (props) => {
  const { ImageUrl, remove } = props
  return (
    <div style={{ position: 'absolute', zIndex: 3, cursor: 'pointer' }} onClick={() => { remove() }}>
      <div className='photo-viewer-container'>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'right', marginRight: '25%', marginBottom: 10 }}>
          <a onClick={() => { remove() }}>
            <img src={CloseIcon} style={{ width: 20 }}></img>
          </a>
        </div>
        <div style={{ display: 'flex', marginBottom: '10px', width: '75%', height: '80%', justifyContent: 'center', alignItems: 'center' }}>
          <img src={ImageUrl}
            onClick={(e) => { e.stopPropagation(); }}
            style={{ maxWidth: '100%', maxHeight: '100%', cursor: 'default' }}
          ></img>
        </div>
      </div>
    </div>
  )
}

export default ImageViewModel